import React, { useState, useEffect } from 'react';

import { useSelector } from 'react-redux';

import { useForm } from 'react-hook-form';

import {
  ActionPortal,
  Checkbox,
  CheckboxWrapper,
  DefaultActionButtons,
  Step,
  LoadingSpin,
  Text,
} from 'components';

import { Gray, Purple } from 'constants/colors';

import { StepPropTypes } from '../../constants/propTypes';

import ContractPDF from '../../components/contractPDF';

export default function Contract(props) {
  const {
    theme, onSubmit, onCancel, onFinalizeSubscription, initialValues: { contract } = {},
  } = props;
  const { formState, register, handleSubmit } = useForm({
    mode: 'all',
    defaultValues: contract,
  });

  const { basicInfo, solutionInfo, financeInfo } = useSelector((state) => state.subscription);

  const [contractPDF, setContractPDF] = useState('');
  const [pdfBlob, setPdfBlob] = useState(null);
  const [pdfSha256, setPdfSha256] = useState('');
  const [loadingContract, setLoadingContract] = useState(true);
  const [failLoadingContract, setFailLoadingContract] = useState(false);
  const [loadingFinalize, setLoadingFinalize] = useState(false);
  const [failFinalize, setFailFinalize] = useState(false);

  const { isValid } = formState;

  useEffect(() => {
    const generateContract = async () => {
      try {
        const { view, pdfBlob: nextPdfBlob, pdfSha256: nextPdfSha256 } = await ContractPDF({
          basicInfo,
          solutionInfo,
          financeInfo,
        });
        setContractPDF(view);
        setPdfBlob(nextPdfBlob);
        setPdfSha256(nextPdfSha256);
      } catch (err) {
        setFailLoadingContract(true);
        console.error(err);
      } finally {
        setLoadingContract(false);
      }
    };

    generateContract();
  }, [basicInfo, financeInfo, solutionInfo]);

  const handleFinalize = async (formData) => {
    setLoadingFinalize(true);
    try {
      await onFinalizeSubscription({ pdfBlob, pdfSha256 });
      setFailFinalize(false);
      onSubmit(formData);
    } catch (err) {
      console.error(err);
      setFailFinalize(true);
    } finally {
      setLoadingFinalize(false);
    }
  };

  return (
    <div style={{ height: '100%', backgroundColor: Gray[200] }}>
      <Step
        headerTitle="Contrato de Locação"
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >

        {!loadingContract && !failLoadingContract
          && (
          <div style={{ width: '100%', height: '100%' }}>
            {contractPDF}
          </div>
          )}

        {loadingContract
          && (
          <div style={{
            width: '100%', height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
          >
            <LoadingSpin
              show={loadingContract}
              weight="5px"
              size="80px"
              backColor={Purple[500]}
              frontColor="transparent"
            />
          </div>
          )}

        <ActionPortal vertical>
          <CheckboxWrapper>
            <Text
              fontSize="14px"
              margin="0 0 12px 0"
              color={Gray[400]}
              fontWeight="400"
            >
              Uma cópia do contrato também foi enviada para o e-mail do gestor.
            </Text>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                type="checkbox"
                id="optIn"
                name="optInContract"
                color={Purple[500]}
                innerRef={register({
                  required: true,
                })}
              />
              <Text
                fontSize="14px"
                color={Gray[300]}
                fontWeight="400"
              >
                Li e concordo com todos os termos e cláusulas mencionadas no Contrato de Locação dispostos acima.
              </Text>
            </div>
          </CheckboxWrapper>

          {!loadingFinalize && (
            <>
              {failFinalize
                && (
                <div style={{
                  display: 'grid', rowGap: '18px', textAlign: 'center', padding: '25px',
                }}
                >
                  <label>Ocorreu um erro inesperado ao tentar finalizar a contratação !</label>
                  <label>Tente novamente dentro de alguns instantes ou entre em contato com nosso financeiro.</label>
                </div>
                )}
              <DefaultActionButtons
                theme={theme}
                isValid={isValid}
                backButtonStyle={{
                  iconPosition: 'left',
                  border: 'none',
                  customBackgroundColor: 'transparent',
                  customIconColor: Gray[400],
                  customTextColor: Gray[400],
                  title: 'Passo Anterior',
                }}
                nextButtonStyle={{
                  customBackgroundColor: Purple[500],
                  customIconColor: Gray[100],
                  customTextColor: Gray[100],
                  title: 'Finalizar contratação',
                }}
                onCancel={onCancel}
                onSubmit={() => handleSubmit(handleFinalize)()}
              />
            </>
          )}
        </ActionPortal>
        {loadingFinalize
          && (
          <div style={{
            width: '100%', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
          >
            <LoadingSpin
              show={loadingFinalize}
              weight="5px"
              size="80px"
              backColor={Purple[500]}
              frontColor="transparent"
            />
          </div>
          )}
      </Step>
    </div>
  );
}

Contract.propTypes = StepPropTypes;
